<template>
  <div class="container upcoming-content home-p-color">
    <div class="content center-margin">
      <div class="step">
        <h2 class="title center-aligned home-color">
          {{ $t('ppwc.p71') }}
        </h2>
        <el-table
          border
          :data="tableData"
          :show-header="false"
          style="width: 100%"
        >
          <el-table-column
            prop="name"
            min-width="100"
          />
          <el-table-column
            prop="content"
            min-width="200"
          >
            <template slot-scope="scope">
              <p><strong>{{ scope.row.content }}</strong></p>
            </template>
          </el-table-column>
        </el-table>
        <div class="buttons">
          <div
            class="confirm"
            @click="confirm"
          >
            <p>{{ $t('ppwc.p12') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    param: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      // tableData: []
    }
  },
  computed: {
    tableData() {
      let idType = {
        '1': this.$t('ppwc.p24'),
        '2': this.$t('ppwc.p25'),
        '3': this.$t('ppwc.p26')
      }
      return [
        {
          name: this.$t('ppwc.p8'),
          content: this.param.serial_no
        },
        {
          name: this.$t('ppwc.p20'),
          content: this.param.name
        },
        {
          name: idType[this.param.id_type],
          content: this.param.id_num
        },
        {
          name: this.$t('ppwc.p28'),
          content: this.param.platform
        },
        {
          name: this.$t('ppwc.p33'),
          content: this.param.birthday
        },
        {
          name: this.$t('ppwc.p38'),
          content: this.param.preferred
        },
        {
          name: this.$t('ppwc.p14'),
          content: this.param.email
        },
      ]
    }
  },
  created() {
  },
  methods: {
    confirm() {
      this.$router.push({name: 'events'})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.banner_img {
  height: 410px;
  background: url("/official/static/img/events/banner1.jpg") center center;
  background-repeat: no-repeat;
}
.upcoming-content {
  padding-top: 65px;
  padding-bottom: 65px;
  .content {
    width: 620px;
  }
}
.step {
  .title {
    font-size: 26px;
    margin: 0px 0px 30px 0px;
  }
  .demo-ruleForm {
    /deep/.el-input__inner {
      font-size: 18px;
      height: 50px;
      // font-weight: bold;
    }
  }
  .buttons {
    text-align: center;
    margin-top: 50px;
  }
  .confirm {
    width: 223px;
    height: 42px;
    // margin: 30px auto 0px auto;
    display: inline-block;
    margin-left: 40px;
    background: url('/official/static/img/events/activate/banner_01.png') no-repeat center center;
    cursor: pointer;
    p {
      text-align: center;
      line-height: 42px;
      font-size: 24px;
      color: #fff;
    }
  }
}
</style>
